<script setup lang="ts">
defineProps<{ mainMenuItems: NavMenuItem[]; topMenuItems: NavMenuItem[] }>();
</script>

<template>
  <SiteHeaderTop :menu-items="topMenuItems" />
  <UHeader id="site-header" mode="slideover">
    <template #left>
      <SiteLogo />
    </template>
    <UNavigationMenu :items="mainMenuItems" content-orientation="vertical" label-key="title" variant="link" />
    <template #body>
      <UNavigationMenu :items="mainMenuItems" orientation="vertical" label-key="title" class="-mx-2.5" />
    </template>
  </UHeader>
</template>
